// Module
var code = "<div> <cu-radio-group value=\"$ctrl.value\" on-change=\"$ctrl.onChange($cuValue)\"> <cu-radio-option ng-repeat=\"option in $ctrl.options\" ng-disabled=\"$ctrl.lockedKey\" value=\"{{ option.value }}\" label=\"{{ option.label }}\"></cu-radio-option> </cu-radio-group> </div> ";
// Exports
module.exports = code;